import { Button, Text } from '@frontend/design-system';
import { drawerHeaderCenterStyles, drawerHeaderCompactStyles, drawerHeaderStyles } from '../contacts-drawer.styles';

type ContactsDrawerHeaderProps = {
  title: string;
  subtitle?: string;
  count?: number;
  onClose: () => void;
  compact?: boolean;
};

export const ContactsDrawerHeader = ({ title, subtitle, count, onClose, compact }: ContactsDrawerHeaderProps) => {
  return (
    <div css={[drawerHeaderStyles, compact && drawerHeaderCompactStyles]}>
      <Button iconName='back' variant='secondary' onClick={onClose} />
      <div css={drawerHeaderCenterStyles}>
        <Text size='large' weight='bold'>
          {title}
        </Text>
        {subtitle && (
          <Text size='small' color='light'>
            {subtitle}
          </Text>
        )}
      </div>
      {count ? (
        <Text size='small' color='light'>
          {count}
        </Text>
      ) : null}
    </div>
  );
};
